import {
  // newArrivalsImageGallery,
  // valentinesImageBanner,
  // intWomensDay2019,
  // doingGoodTastesGreat,
  // marisPicks,
  // theGrapefulClub,
  // springSaleBoldPack,
  // springSaleCrispPack,
  // springSaleImageBanner,
  // grapefulExclusivesQ219,
  // mothersDayGifBanner19,
  // NonProfitHighlight,
  // redWhiteBlueGlitterBottle,
  // promotionsSnackBar,
  bestSellersImageGallery,
  // oneHopeTextBanner,
  // everyBottleGivesBack,
  bottomFooterTextBanner,
  DrivenByPurpose,
  // MakeADifference,
  // CelebratePrideMonth,
  RaiseAGlassForGood,
  BeYourOwnBoss,
  // SummerIsLit,
  // rwbGlitterBottleNewLayout,
  // pinotForPawsEtching,
  // promotionsSnackBarJuly19,
  // leAnnRimes,
  // leAnnSnackbar,
  grillAndChill,
  // grillChillSnackbar,
  // halfOffTastingEvent,
  // endlessSummerSnackbar,
  // endlessSummerPromo,
  // oct1stSnackbar,
  // pinkGlitterChardPromo,
  // endlessSummerSnackbar2,
  // bronzeGlitterPromo,
  // freePCSnackbar,
  // blackFridayHero,
  // blackFridayPromo,
  // gatherGiveTextBanner,
  celebratingFiveMillionHero,
  decFreePCSnackbar,
  // goldShimmerPromo,
  // NonProfitHighlightCureAlz,
  NonProfitHighlightOHFoundation,
  // freeShippingGiftsPromo,
  sparkling4PackPromo,
  gatherGiveTextBannerDec3,
  holidayMagnumPromo,
  freePCMembershipPromo,
  janFreePCSnackbar,
  NonProfitHighlightFeb20,
  intlWomensDayHero,
  intlWomensDayTextBanner,
  sipSpringPromo,
  JoinACommunity,
  WeMakeWine,
  RaiseAGlassForGood20,
  aprFreePCSnackbar,
  deliveringHopeTextBanner,
  aprPwpPromo,
  earnAnIncome,
  apr2020Hero,
  HostAVirtualTasting,
  deliveringHopeTextBannerSupercampaigns,
  mayPwpPromo,
  junePwpPromo,
  prideHero,
  prideTextBanner,
  earnAnIncomeJun20,
  WeMakeWineJun20,
  consciousKidHero,
  consciousKidTextBanner,
  julyPwpPromo,
  weMakeWineTextBanner,
  weMakeWineHero,
  consciousKidTile,
  weMakeWineHero2,
  augPwpPromo,
  whyHungerTile,
  sepPwpPromo,
  newArrivalsImageGallery,
  HostAVirtualTastingSep20,
  susanKomenTile,
  bcam2020Hero,
  octPwpPromo,
  susanKomenTileOct,
  earnAnIncomeOct20,
  HostAVirtualTastingOct20,
  rewardsFeatureHighlight,
  holiday20Hero,
  blackFridayHero20,
  novPwpPromo,
  holiday20Fundraiser,
  flashSaleWeek1Snackbar,
  flashSaleWeek2Snackbar,
  flashSaleWeek3Snackbar,
  blackFridayTextBanner,
  popFizzClinkTextBanner,
  dec20Hero,
  decPwpPromo,
  earnAnIncomeDec20,
  HostAVirtualTastingDec20,
  jan21Hero,
  jan21PwpPromo,
  january21Fundraiser,
  earnAnIncomeJan21,
  rewardsFeatureHighlightFeb,
  feb21PwpPromo,
  feb21Fundraiser,
  HostAVirtualTastingFeb21,
  tastingKitPromo,
  mar21PwpPromo,
  mar21Fundraiser,
  tastingKitSnackBar,
  apr21PwpPromo,
  apr21Fundraiser,
  may21PwpPromo,
  may21Fundraiser,
  memorialDay21Snackbar,
  june21PwpPromo,
  june21Fundraiser,
} from './HomePageComponents';

/* Component Types
promotionBanner
fullWidthBanner
rightImageBanner
imageGallery
shopCategory
*/

/* ADD or REMOVE TEXT 'DISABLED' to disable or enable a component */

export const config = {
  // Production Homepages
  '2021-06-01T07:01:00.000Z': [
    jan21Hero,
    weMakeWineTextBanner,
    june21PwpPromo,
    bestSellersImageGallery,
    tastingKitPromo,
    june21Fundraiser,
    earnAnIncomeJan21,
    HostAVirtualTastingFeb21,
    rewardsFeatureHighlightFeb,
    bottomFooterTextBanner,
  ],
  '2021-05-25T07:01:00.000Z': [
    memorialDay21Snackbar,
    jan21Hero,
    weMakeWineTextBanner,
    may21PwpPromo,
    bestSellersImageGallery,
    tastingKitPromo,
    may21Fundraiser,
    earnAnIncomeJan21,
    HostAVirtualTastingFeb21,
    rewardsFeatureHighlightFeb,
    bottomFooterTextBanner,
  ],
  '2021-05-01T07:01:00.000Z': [
    tastingKitSnackBar,
    jan21Hero,
    weMakeWineTextBanner,
    may21PwpPromo,
    bestSellersImageGallery,
    tastingKitPromo,
    may21Fundraiser,
    earnAnIncomeJan21,
    HostAVirtualTastingFeb21,
    rewardsFeatureHighlightFeb,
    bottomFooterTextBanner,
  ],
  '2021-04-01T07:01:00.000Z': [
    tastingKitSnackBar,
    jan21Hero,
    weMakeWineTextBanner,
    apr21PwpPromo,
    bestSellersImageGallery,
    tastingKitPromo,
    apr21Fundraiser,
    earnAnIncomeJan21,
    HostAVirtualTastingFeb21,
    rewardsFeatureHighlightFeb,
    bottomFooterTextBanner,
  ],
  '2021-03-01T08:01:00.000Z': [
    tastingKitSnackBar,
    jan21Hero,
    weMakeWineTextBanner,
    mar21PwpPromo,
    bestSellersImageGallery,
    tastingKitPromo,
    mar21Fundraiser,
    earnAnIncomeJan21,
    HostAVirtualTastingFeb21,
    rewardsFeatureHighlightFeb,
    bottomFooterTextBanner,
  ],
  '2021-02-01T08:01:00.000Z': [
    jan21Hero,
    weMakeWineTextBanner,
    feb21PwpPromo,
    bestSellersImageGallery,
    tastingKitPromo,
    feb21Fundraiser,
    earnAnIncomeJan21,
    HostAVirtualTastingFeb21,
    rewardsFeatureHighlightFeb,
    bottomFooterTextBanner,
  ],
  '2021-01-01T08:01:00.000Z': [
    jan21Hero,
    weMakeWineTextBanner,
    jan21PwpPromo,
    bestSellersImageGallery,
    january21Fundraiser,
    earnAnIncomeJan21,
    HostAVirtualTastingDec20,
    rewardsFeatureHighlight,
    bottomFooterTextBanner,
  ],
  '2020-12-01T08:01:00.000Z': [
    dec20Hero,
    popFizzClinkTextBanner,
    decPwpPromo,
    bestSellersImageGallery,
    holiday20Fundraiser,
    earnAnIncomeDec20,
    HostAVirtualTastingDec20,
    rewardsFeatureHighlight,
    bottomFooterTextBanner,
  ],
  '2020-11-24T08:01:00.000Z': [
    blackFridayHero20,
    blackFridayTextBanner,
    novPwpPromo,
    bestSellersImageGallery,
    holiday20Fundraiser,
    earnAnIncomeOct20,
    HostAVirtualTastingOct20,
    rewardsFeatureHighlight,
    bottomFooterTextBanner,
  ],
  '2020-11-17T08:01:00.000Z': [
    flashSaleWeek3Snackbar,
    holiday20Hero,
    weMakeWineTextBanner,
    novPwpPromo,
    bestSellersImageGallery,
    holiday20Fundraiser,
    earnAnIncomeOct20,
    HostAVirtualTastingOct20,
    rewardsFeatureHighlight,
    bottomFooterTextBanner,
  ],
  '2020-11-10T08:01:00.000Z': [
    flashSaleWeek2Snackbar,
    holiday20Hero,
    weMakeWineTextBanner,
    novPwpPromo,
    bestSellersImageGallery,
    holiday20Fundraiser,
    earnAnIncomeOct20,
    HostAVirtualTastingOct20,
    rewardsFeatureHighlight,
    bottomFooterTextBanner,
  ],
  '2020-11-03T08:01:00.000Z': [
    flashSaleWeek1Snackbar,
    holiday20Hero,
    weMakeWineTextBanner,
    novPwpPromo,
    bestSellersImageGallery,
    holiday20Fundraiser,
    earnAnIncomeOct20,
    HostAVirtualTastingOct20,
    rewardsFeatureHighlight,
    bottomFooterTextBanner,
  ],
  '2020-11-01T07:01:00.000Z': [
    holiday20Hero,
    weMakeWineTextBanner,
    novPwpPromo,
    bestSellersImageGallery,
    holiday20Fundraiser,
    earnAnIncomeOct20,
    HostAVirtualTastingOct20,
    rewardsFeatureHighlight,
    bottomFooterTextBanner,
  ],
  '2020-10-01T14:01:00.000Z': [
    bcam2020Hero,
    weMakeWineTextBanner,
    octPwpPromo,
    bestSellersImageGallery,
    susanKomenTileOct,
    earnAnIncomeOct20,
    HostAVirtualTastingOct20,
    rewardsFeatureHighlight,
    bottomFooterTextBanner,
  ],
  '2020-10-01T07:01:00.000Z': [
    bcam2020Hero,
    weMakeWineTextBanner,
    octPwpPromo,
    bestSellersImageGallery,
    susanKomenTileOct,
    earnAnIncomeOct20,
    HostAVirtualTastingOct20,
    bottomFooterTextBanner,
  ],
  '2020-09-03T07:01:00.000Z': [
    weMakeWineHero2,
    weMakeWineTextBanner,
    sepPwpPromo,
    bestSellersImageGallery,
    susanKomenTile,
    earnAnIncomeJun20,
    HostAVirtualTastingSep20,
    bottomFooterTextBanner,
  ],
  '2020-09-01T07:01:00.000Z': [
    weMakeWineHero2,
    weMakeWineTextBanner,
    sepPwpPromo,
    bestSellersImageGallery,
    whyHungerTile,
    earnAnIncomeJun20,
    HostAVirtualTastingSep20,
    bottomFooterTextBanner,
  ],
  '2020-08-01T07:01:00.000Z': [
    aprFreePCSnackbar,
    weMakeWineHero2,
    weMakeWineTextBanner,
    augPwpPromo,
    bestSellersImageGallery,
    whyHungerTile,
    earnAnIncomeJun20,
    HostAVirtualTasting,
    bottomFooterTextBanner,
  ],
  '2020-07-01T15:01:00.000Z': [
    aprFreePCSnackbar,
    weMakeWineHero,
    weMakeWineTextBanner,
    julyPwpPromo,
    bestSellersImageGallery,
    consciousKidTile,
    earnAnIncomeJun20,
    HostAVirtualTasting,
    bottomFooterTextBanner,
  ],
  '2020-07-01T07:01:00.000Z': [
    aprFreePCSnackbar,
    consciousKidHero,
    consciousKidTextBanner,
    julyPwpPromo,
    bestSellersImageGallery,
    earnAnIncomeJun20,
    WeMakeWineJun20,
    HostAVirtualTasting,
    bottomFooterTextBanner,
  ],
  '2020-06-22T19:01:00.000Z': [
    aprFreePCSnackbar,
    consciousKidHero,
    consciousKidTextBanner,
    junePwpPromo,
    bestSellersImageGallery,
    earnAnIncomeJun20,
    WeMakeWineJun20,
    HostAVirtualTasting,
    bottomFooterTextBanner,
  ],
  // immediate updates
  '2020-06-18T06:01:00.000Z': [
    aprFreePCSnackbar,
    prideHero,
    prideTextBanner,
    junePwpPromo,
    bestSellersImageGallery,
    earnAnIncomeJun20,
    WeMakeWineJun20,
    HostAVirtualTasting,
    bottomFooterTextBanner,
  ],
  '2020-06-01T06:01:00.000Z': [
    aprFreePCSnackbar,
    prideHero,
    prideTextBanner,
    junePwpPromo,
    bestSellersImageGallery,
    earnAnIncome,
    WeMakeWine,
    HostAVirtualTasting,
    bottomFooterTextBanner,
  ],
  '2020-05-01T08:01:00.000Z': [
    aprFreePCSnackbar,
    apr2020Hero,
    deliveringHopeTextBannerSupercampaigns,
    mayPwpPromo,
    bestSellersImageGallery,
    earnAnIncome,
    WeMakeWine,
    HostAVirtualTasting,
    bottomFooterTextBanner,
  ],
  // '2020-04-15T08:01:00.000Z': [
  //   aprFreePCSnackbar,
  //   apr2020Hero,
  //   deliveringHopeTextBannerSupercampaigns,
  //   aprPwpPromo,
  //   bestSellersImageGallery,
  //   earnAnIncome,
  //   WeMakeWine,
  //   HostAVirtualTasting,
  //   bottomFooterTextBanner,
  // ],
  // '2020-04-01T08:01:00.000Z': [
  //   aprFreePCSnackbar,
  //   apr2020Hero,
  //   deliveringHopeTextBanner,
  //   aprPwpPromo,
  //   bestSellersImageGallery,
  //   earnAnIncome,
  //   WeMakeWine,
  //   HostAVirtualTasting,
  //   bottomFooterTextBanner,
  // ],
  // '2020-03-17T08:01:00.000Z': [
  //   janFreePCSnackbar,
  //   intlWomensDayHero,
  //   intlWomensDayTextBanner,
  //   sipSpringPromo,
  //   bestSellersImageGallery,
  //   JoinACommunity,
  //   WeMakeWine,
  //   RaiseAGlassForGood20,
  //   bottomFooterTextBanner,
  // ],
  // '2020-03-01T08:01:00.000Z': [
  //   janFreePCSnackbar,
  //   intlWomensDayHero,
  //   intlWomensDayTextBanner,
  //   freePCMembershipPromo,
  //   bestSellersImageGallery,
  //   JoinACommunity,
  //   WeMakeWine,
  //   RaiseAGlassForGood20,
  //   bottomFooterTextBanner,
  // ],
  // '2020-02-01T08:01:00.000Z': [
  //   janFreePCSnackbar,
  //   celebratingFiveMillionHero,
  //   gatherGiveTextBannerDec3,
  //   freePCMembershipPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightFeb20,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2020-02-01T08:01:00.000Z': [
  //   janFreePCSnackbar,
  //   celebratingFiveMillionHero,
  //   gatherGiveTextBannerDec3,
  //   freePCMembershipPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightFeb20,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // New Year Config:
  // '2020-01-01T08:01:00.000Z'
  // '2020-01-01T08:01:00.000Z': [
  //   janFreePCSnackbar,
  //   celebratingFiveMillionHero,
  //   gatherGiveTextBannerDec3,
  //   freePCMembershipPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightOHFoundation,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // Revert to Giving Tuesday; Dec 20 - 31
  // '2019-12-20T08:01:00.000Z'
  // '2019-12-20T08:01:00.000Z': [
  //   decFreePCSnackbar,
  //   celebratingFiveMillionHero,
  //   gatherGiveTextBannerDec3,
  //   holidayMagnumPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightOHFoundation,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],

  // Flash Sale 2; Dec 18 - Dec 19
  // 2019-12-18T08:01:00.000Z
  // '2019-12-18T06:01:00.000Z': [
  //   decFreePCSnackbar,
  //   celebratingFiveMillionHero,
  //   gatherGiveTextBannerDec3,
  //   sparkling4PackPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightOHFoundation,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],

  // Revert to Giving Tuesday; Dec 12 - 17
  // 2019-12-12T08:01:00.000Z
  // '2019-12-12T08:01:00.000Z': [
  //   decFreePCSnackbar,
  //   celebratingFiveMillionHero,
  //   gatherGiveTextBannerDec3,
  //   holidayMagnumPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightOHFoundation,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],

  // Flash Sale 1; Dec 10 - 11
  // 2019-12-10T08:00:00.000Z
  // '2019-12-10T08:00:00.000Z': [
  //   decFreePCSnackbar,
  //   celebratingFiveMillionHero,
  //   gatherGiveTextBannerDec3,
  //   freeShippingGiftsPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightOHFoundation,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // Giving Tuesday themed homepage Dec 3 - 9; dec 12 - 16; dec 19 - 31
  // 2019-12-03T08:01:00.000Z (post Black Friday)
  // '2019-12-03T08:01:00.000Z': [
  //   decFreePCSnackbar,
  //   celebratingFiveMillionHero,
  //   gatherGiveTextBannerDec3,
  //   holidayMagnumPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightOHFoundation,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // Black Friday homepage config -
  //schedule for 2019-11-29T06:00:00.000Z:
  // '2019-11-29T06:00:00.000Z': [
  //   blackFridayHero,
  //   gatherGiveTextBanner,
  //   blackFridayPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightCureAlz,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-11-01T05:00:00.000Z': [
  //   oct1stSnackbar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   bronzeGlitterPromo,
  //   bestSellersImageGallery,
  //   NonProfitHighlightCureAlz,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-10-01T05:00:00.000Z': [
  //   oct1stSnackbar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   pinkGlitterChardPromo,
  //   bestSellersImageGallery,
  //   // NonProfitHighlight,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-09-30T05:00:00.000Z': [
  //   endlessSummerSnackbar2,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   endlessSummerPromo,
  //   bestSellersImageGallery,
  //   // NonProfitHighlight,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-09-08T05:00:00.000Z': [
  //   leAnnSnackbar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   halfOffTastingEvent,
  //   bestSellersImageGallery,
  //   // NonProfitHighlight,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-09-02T05:00:00.000Z': [
  //   leAnnSnackbar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   halfOffTastingEvent,
  //   bestSellersImageGallery,
  //   MakeADifference,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-08-20T05:00:00.000Z': [
  //   grillChillSnackbar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   grillAndChill,
  //   bestSellersImageGallery,
  //   MakeADifference,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-07-30T05:00:00.000Z': [
  //   leAnnSnackbar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   leAnnRimes,
  //   bestSellersImageGallery,
  //   MakeADifference,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-07-09T05:00:00.000Z': [
  //   promotionsSnackBarJuly19,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   pinotForPawsEtching, //change to furbabies
  //   bestSellersImageGallery,
  //   MakeADifference,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-07-02T05:00:00.000Z': [
  //   promotionsSnackBar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   rwbGlitterBottleNewLayout,
  //   bestSellersImageGallery,
  //   MakeADifference,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-06-18T05:00:00.000Z': [
  //   promotionsSnackBar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   SummerIsLit,
  //   bestSellersImageGallery,
  //   MakeADifference,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  //
  // '2019-06-01T05:00:00.000Z': [
  //   promotionsSnackBar,
  //   everyBottleGivesBack,
  //   oneHopeTextBanner,
  //   CelebratePrideMonth,
  //   bestSellersImageGallery,
  //   MakeADifference,
  //   DrivenByPurpose,
  //   RaiseAGlassForGood,
  //   BeYourOwnBoss,
  //   bottomFooterTextBanner,
  // ],
  // '2019-05-14T05:00:00.000Z': [
  //   redWhiteBlueGlitterBottle,
  //   bestSellersImageGallery,
  //   newArrivalsImageGallery,
  //   theGrapefulClub,
  //   marisPicks,
  // ],
  // '2019-05-06T05:00:00.000Z': [
  //   grapefulExclusivesQ219,
  //   bestSellersImageGallery,
  //   newArrivalsImageGallery,
  //   theGrapefulClub,
  //   marisPicks,
  // ],
  // '2019-04-15T05:00:00Z': [
  //   mothersDayGifBanner19,
  //   bestSellersImageGallery,
  //   newArrivalsImageGallery,
  //   theGrapefulClub,
  //   marisPicks,
  // ],
  // '2019-04-03T05:00:00Z': [
  //   springSaleImageBanner,
  //   springSaleBoldPack,
  //   springSaleCrispPack,
  //   bestSellersImageGallery,
  //   newArrivalsImageGallery,
  // ],
  // '2019-03-08T05:00:00Z': [
  //   womensMonth2019,
  //   oneHopeTextBanner,
  //   bestSellersImageGallery,
  //   newArrivalsImageGallery,
  //   theGrapefulClub,
  //   marisPicks,
  // ],
  // '2019-02-15T05:00:00Z': [
  //   intWomensDay2019,
  //   oneHopeTextBanner,
  //   bestSellersImageGallery,
  //   newArrivalsImageGallery,
  //   theGrapefulClub,
  //   marisPicks,
  // ],
  // // Vday promo
  // '2019-01-11T05:00:00Z': [
  //   valentinesImageBanner,
  //   oneHopeTextBanner,
  //   bestSellersImageGallery,
  //   newArrivalsImageGallery,
  //   theGrapefulClub,
  //   marisPicks,
  // ],
  // '2019-01-01T05:00:00Z': [
  //   doingGoodTastesGreat,
  //   oneHopeTextBanner,
  //   bestSellersImageGallery,
  //   newArrivalsImageGallery,
  //   theGrapefulClub,
  //   marisPicks,
  // ],
  // End Production Homepages
};
